<template>
    <div>
        <div>
            <div class="form-check">
                <input
                    v-model="acceptsGeneralPrivacy"
                    id="acceptsGeneralPrivacy"
                    type="checkbox"
                    class="checkbox"
                />
                <label
                    for="acceptsGeneralPrivacy"
                    class="form-check-label"
                >
                    <span class="form-check-label__text">
                        <PrivacyConsentGeneralInfo/>
                    </span>
                </label>
                <div>
                    <input
                        v-model="acceptsCustomPrivacy"
                        id="acceptsCustomPrivacy"
                        type="checkbox"
                        class="checkbox"
                    />

                    <label
                        for="acceptsCustomPrivacy"
                        class="form-check-label"
                    >
                        <span class="form-check-label__text">
                            <PrivacyConsentCustomInfo/>
                        </span>
                    </label>
                </div>
            </div>

            <PrivacyConsentWithdrawalInfo/>

            <div class="btn__group">
                <CustomButton
                    :isLoading="isLoading"
                    @click="onSave"
                    class="btn btn--md btn--w-144 btn__primary"
                >
                    {{ $t('save') | capitalize }}
                </CustomButton>
                <button
                    @click="$emit('cancel')"
                    class="btn btn--md btn--w-144 btn__primary"
                >
                    {{ $t(cancelLabel) | capitalize }}
                </button>
            </div>
        </div>

    </div>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex';
    import UserService from '@core/services/user/UserService';
    import { errorGuard } from '@app/utils';

    export default {
        name: 'GdprUpdateContainer',
        props: {
            cancelLabel: {
                type: String,
                required: false,
                default: 'cancel'
            },
            isInModal: {
                type: Boolean,
                required: false,
                default: false
            }
        },
        data() {
            return {
                error: '',
                isLoading: false,
                acceptsGeneralPrivacy: null,
                acceptsCustomPrivacy: null,
            };
        },
        computed: {
            ...mapGetters('data/authentication', [
                'user',
            ]),
        },
        created() {
            this.acceptsGeneralPrivacy = this.user.acceptsGeneralPrivacy;
            this.acceptsCustomPrivacy = this.user.acceptsCustomPrivacy;
        },
        methods: {
            ...mapActions('data/authentication', [
                'setUserData',
            ]),
            ...mapActions('errors', [
                'showError',
            ]),
            async onSave() {
                const isGeneralModified = this.user.acceptsGeneralPrivacy !== this.acceptsGeneralPrivacy;
                const isCustomModified = this.user.acceptsCustomPrivacy !== this.acceptsCustomPrivacy;

                if (isGeneralModified || isCustomModified) {
                    this.error = '';
                    this.isLoading = true;
                    await errorGuard({
                        action: async () => {
                            await UserService.getInstance().updatePrivacy(
                                this.acceptsGeneralPrivacy,
                                this.acceptsCustomPrivacy
                            );
                            this.setUserData({
                                key: 'acceptsGeneralPrivacy',
                                value: this.acceptsGeneralPrivacy
                            });
                            this.setUserData({
                                key: 'acceptsCustomPrivacy',
                                value: this.acceptsCustomPrivacy
                            });
                            this.$emit('savedSuccess');
                        },
                        onError: (e) => {
                            if (this.isInModal) {
                                this.error = 'Something went wrong. Please try again';
                            } else {
                                this.showError(e);
                            }
                        },
                        showGlobalError: false,
                    });
                    this.isLoading = false;
                }
                this.$emit('savedSuccess');
            },
        },
    };
</script>


// WEBPACK FOOTER //
// src/app/modules/userProfile/gdpr/GdprUpdateContainer.vue